export default __webpack_public_path__ + "static/media/sd-vid-1.7f4b622d.mp4";